import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

function Navbar() {

    const [menuOpen, setMenuOpen] = useState(false);
    const { t, i18n } = useTranslation();

    // cerrar al hacer scroll
    useEffect(() => {
        const handleScroll = () => setMenuOpen(false);
        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <nav className="navbar">

            {/* LOGO */}
            <Link
                to="/"
                className="logo"
                onClick={() => window.scrollTo(0, 0)}
            >
                <img src="/logo-nuevo-lcb.png" alt="Limpiezas Costa Blanca" />
            </Link>

            <div className="lang-switch">
                <button
                    className={i18n.language === "es" ? "active" : ""}
                    onClick={() => i18n.changeLanguage("es")}
                >
                    🇪🇸 ES
                </button>

                <button
                    className={i18n.language === "en" ? "active" : ""}
                    onClick={() => i18n.changeLanguage("en")}
                >
                    🇬🇧 EN
                </button>
            </div>

            {/* HAMBURGUESA */}
            <div
                className={`hamburger ${menuOpen ? "active" : ""}`}
                onClick={() => setMenuOpen(!menuOpen)}
            >
                <span></span>
                <span></span>
                <span></span>
            </div>

            {/* LINKS */}
            <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
                <li>
                    <a href="/#inicio" onClick={() => setMenuOpen(false)}>
                        {t("menu.home")}
                    </a>
                </li>

                <li>
                    <a href="/#servicios" onClick={() => setMenuOpen(false)}>
                        {t("menu.services")}
                    </a>
                </li>

                <li>
                    <a href="/#sobre" onClick={() => setMenuOpen(false)}>
                        {t("menu.about")}
                    </a>
                </li>

                <li>
                    <a href="/#contacto" onClick={() => setMenuOpen(false)}>
                        {t("menu.contact")}
                    </a>
                </li>
            </ul>
            {/* BOTÓN TEL */}
            <div className="nav-right">
                <a href="tel:+34611009814" className="phone-btn">
                    📞 +34 611 00 98 14
                </a>
            </div>

        </nav>
    );
}

export default Navbar;